import {ICON_TYPES} from '../constants';

export const UpRightArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'>
      <path
        d='M11.3501 1.69717V8.48939C11.3501 8.73634 11.1499 8.93656 10.9029 8.93656C10.656 8.93656 10.4557 8.73634 10.4557 8.48939V2.77682L1.6135 11.619C1.52616 11.7063 1.41174 11.75 1.29729 11.75C1.18284 11.75 1.06842 11.7063 0.981081 11.619C0.806437 11.4444 0.806437 11.1612 0.981081 10.9866L9.82334 2.14434H4.11069C3.86374 2.14434 3.66352 1.94413 3.66352 1.69717C3.66352 1.45022 3.86374 1.25 4.11069 1.25H10.9029C11.1499 1.24998 11.3501 1.45022 11.3501 1.69717Z'
        fill='#141414'
        stroke='black'
        strokeWidth='0.75'
      />
    </svg>
  );
};

UpRightArrow.iconType = ICON_TYPES.UP_RIGHT_ARROW;
